import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  defaultTo,
  any,
  complement,
  map,
  split,
  flatten,
  unless,
  startsWith,
  concat,
  pipe,
  filter
} from 'ramda'
import withFieldError from 'components/form/with-error'

export const MatchHashtag = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter hashtag e.g. #hashtag',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

MatchHashtag.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const MatchHashtagWithError = withFieldError(MatchHashtag)

const noValue = either(isNil, isEmpty)
const hasInvalidHashtags = any(complement(window.twttr.txt.isValidHashtag))

export const validate = cond([
  [either(noValue, hasInvalidHashtags), always('Please enter valid hashtags')]
])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty)),
  map(unless(startsWith('#'), concat('#')))
)

const MatchHashtagField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={MatchHashtagWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

MatchHashtagField.propTypes = {
  name: PropTypes.string
}

export default MatchHashtagField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/match-hashtag/index.js